import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import WebFont from 'webfontloader';
import Container from './elements/Container';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import SignUp from './components/SignUp';
import { Helmet } from 'react-helmet';
import favicon from "./assets/img/favicon.ico";
import Background from './elements/Backgroud';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header';
import { ProviderToggle } from './context/ContextToggle';
import { ProviderAlert } from './context/ContextAlert';
import { AuthProvider } from './context/AuthContext';
import { BrandingProvider } from './context/BrandingContext';
import PrivateRoute from './components/PrivateRoute';
import MenuProtectedRoute from './components/MenuProtectedRoute';
import RegisterSale from './components/RegisterSale';
import ProductForm from './components/ProductManagment';
import CategoriesForm from './components/Categories';
import SupplierManagment from './components/SupplierManagment';
import Sales from './components/Sales';
import StockManagment from './components/StockManagment';
import Items from './components/Items';
import ModernExpense from './components/ModernExpense'
import PaymentPlan from './components/PaymentPlan'
import PurchaseOrders from './components/PurchaseOrders';
import Pos from './components/Pos';
import ListaCompra from './pages/purchase/ListaCompra';
import DetalleCompra from './pages/purchase/DetalleCompra';
import ReporteCompras from './pages/purchase/ReporteCompras';
import ReporteVentas from './pages/sales/ReporteVentas';
import RegistrarStock from './pages/stock/RegistrarStock';
import RegisterCustomer from './pages/customer/RegisterCustomer';
import CustomerManagement from './pages/customer/CustomerManagement';
import CustomerProfile from './pages/customer/CustomerProfile';
import PetManagement from './pages/pet/PetManagement';
import AppointmentManagement from './pages/appointment/AppointmentManagement';
import AppointmentList from './pages/appointment/AppointmentList';
import BathReminderPanel from './pages/appointment/BathReminderPanel';
import NotificationManagement from './pages/notification/NotificationManagement';
import CollectionManagement from './pages/collection/CollectionManagement';
import CollectionProductManagement from './pages/collection/CollectionProductManagement';
import GroomingDetail from './pages/grooming/GroomingDetail';
import LoyaltyCard from './components/LoyaltyCard';
import UserManagement from './pages/user/UserManagement';
import EmployeeManagement from './pages/employee/EmployeeManagement';
import RoleActionManagement from './pages/action/RoleActionManagement';
import CostCalculator from './components/CostCalculator';
import SizeSpecGarmentTypeManagement from './pages/admin/SizeSpecGarmentTypeManagement';
import TaxManagement from './pages/tax/TaxManagement';
import InventoryManagement from './pages/inventory/InventoryManagement';
import InventoryOpeningManagement from './pages/inventory/InventoryOpeningManagement';
import BulkConfigManagement from './pages/bulk/BulkConfigManagement';


WebFont.load({
  google: {
    families: ['Montserrat', 'sans-serif']
  }
})


const Index = () => {
  return (
    <>
      <Helmet>
        <link rel="shortcut icon" href={favicon} type="image/x-icon" />
        <title>
          Inicio
        </title>
      </Helmet>
      <AuthProvider>
        <Header></Header>
        <BrowserRouter>
          <Container>
            <Routes>
              <Route path="/inicio-sesion" element={<Login />} />
              <Route path="/registro" element={<SignUp />} />
              <Route path="/registrar-venta" element={
                <MenuProtectedRoute>
                  <RegisterSale />
                </MenuProtectedRoute>
              } />
              <Route path="/creacion-producto" element={
                <MenuProtectedRoute>
                  <ProductForm />
                </MenuProtectedRoute>
              } />
              <Route path="/categorias" element={
                <MenuProtectedRoute>
                  <CategoriesForm />
                </MenuProtectedRoute>
              } />

              <Route path="/proveedores" element={
                <MenuProtectedRoute>
                  <SupplierManagment />
                </MenuProtectedRoute>
              } />
              <Route path="/resumen-ventas" element={
                <MenuProtectedRoute>
                  <Sales />
                </MenuProtectedRoute>
              } />
              <Route path="/stock" element={
                <MenuProtectedRoute>
                  <StockManagment />
                </MenuProtectedRoute>
              } />
                   <Route path="/items" element={
                <MenuProtectedRoute>
                  <Items />
                </MenuProtectedRoute>
              } />
               <Route path="/registro-gasto" element={
                <MenuProtectedRoute>
                  <ModernExpense />
                </MenuProtectedRoute>
              } />
                    <Route path="/payment-plan" element={
                <MenuProtectedRoute>
                  < PaymentPlan/>
                </MenuProtectedRoute>
              } />
                <Route path="/purchase-orders" element={
                <MenuProtectedRoute>
                  <PurchaseOrders />
                </MenuProtectedRoute>
              } />
              <Route path="/purchase" element={
                <MenuProtectedRoute>
                  <ListaCompra />
                </MenuProtectedRoute>
              } />
              <Route path="/compras" element={
                <MenuProtectedRoute>
                  <ListaCompra />
                </MenuProtectedRoute>
              } />
              <Route path="/compras/nueva" element={
                <MenuProtectedRoute>
                  <ListaCompra initialShowModal />
                </MenuProtectedRoute>
              } />
              <Route path="/compras/:id" element={
                <MenuProtectedRoute>
                  <DetalleCompra />
                </MenuProtectedRoute>
              } />
              <Route path="/reportes-compras" element={
                <MenuProtectedRoute>
                  <ReporteCompras />
                </MenuProtectedRoute>
              } />
              <Route path="/reportes-ventas" element={
                <MenuProtectedRoute>
                  <ReporteVentas />
                </MenuProtectedRoute>
              } />
              <Route path="/stock/registrar" element={
                <MenuProtectedRoute>
                  <RegistrarStock />
                </MenuProtectedRoute>
              } />
              <Route path="/registrar-cliente" element={
                <MenuProtectedRoute>
                  < RegisterCustomer/>
                </MenuProtectedRoute>
              } />
              <Route path="/gestion-clientes" element={
                <MenuProtectedRoute>
                  < CustomerManagement/>
                </MenuProtectedRoute>
              } />
              <Route path="/perfil-cliente/:id" element={
                <MenuProtectedRoute>
                  <CustomerProfile />
                </MenuProtectedRoute>
              } />
              <Route path="/gestion-mascotas" element={
                <MenuProtectedRoute>
                  < PetManagement/>
                </MenuProtectedRoute>
              } />
              <Route path="/agendamiento-citas" element={
                <MenuProtectedRoute>
                  < AppointmentManagement/>
                </MenuProtectedRoute>
              } />
              <Route path="/gestion-citas" element={
                <MenuProtectedRoute>
                  < AppointmentList/>
                </MenuProtectedRoute>
              } />
              <Route path="/recordatorios-bano" element={
                <MenuProtectedRoute>
                  <BathReminderPanel />
                </MenuProtectedRoute>
              } />
              <Route path="/gestion-notificaciones" element={
                <MenuProtectedRoute>
                  <NotificationManagement />
                </MenuProtectedRoute>
              } />
               <Route path="/pos" element={
                <MenuProtectedRoute>
                  < Pos/>
                </MenuProtectedRoute>
              } />
              <Route path="/gestion-catalogos" element={
                <MenuProtectedRoute>
                  <CollectionManagement />
                </MenuProtectedRoute>
              } />
              <Route path="/gestion-productos-catalogos" element={
                <MenuProtectedRoute>
                  <CollectionProductManagement />
                </MenuProtectedRoute>
              } />
              <Route path="/detalle-ventas-grooming" element={
                <MenuProtectedRoute>
                  <GroomingDetail />
                </MenuProtectedRoute>
              } />
              <Route path="/fidelizacion" element={
                <MenuProtectedRoute>
                  <LoyaltyCard />
                </MenuProtectedRoute>
              } />
              <Route path="/gestion-usuarios" element={
                <MenuProtectedRoute>
                  <UserManagement />
                </MenuProtectedRoute>
              } />
              <Route path="/gestion-empleados" element={
                <MenuProtectedRoute>
                  <EmployeeManagement />
                </MenuProtectedRoute>
              } />
              <Route path="/gestion-acciones-rol" element={
                <MenuProtectedRoute>
                  <RoleActionManagement />
                </MenuProtectedRoute>
              } />
              <Route path="/calculadora-costos-confeccion" element={
                <MenuProtectedRoute>
                  <CostCalculator />
                </MenuProtectedRoute>
              } />
              <Route path="/admin-medidas-tipos-prenda" element={
                <MenuProtectedRoute>
                  <SizeSpecGarmentTypeManagement />
                </MenuProtectedRoute>
              } />
              <Route path="/gestion-impuestos" element={
                <MenuProtectedRoute>
                  <TaxManagement />
                </MenuProtectedRoute>
              } />
              <Route path="/inventario" element={
                <MenuProtectedRoute>
                  <InventoryManagement />
                </MenuProtectedRoute>
              } />
              <Route path="/inventario-inicial" element={
                <MenuProtectedRoute>
                  <InventoryOpeningManagement />
                </MenuProtectedRoute>
              } />
              <Route path="/configuracion-granel" element={
                <MenuProtectedRoute>
                  <BulkConfigManagement />
                </MenuProtectedRoute>
              } />
              <Route path="/" element={
                <PrivateRoute>
                  <App />
                </PrivateRoute>
              } />
            </Routes>
          </Container>
        </BrowserRouter>
        <Background />
      </AuthProvider>
    </>
  );
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrandingProvider>
      <AuthProvider>
        <ProviderAlert>
          <ProviderToggle>
            <Index />
          </ProviderToggle>
        </ProviderAlert>
      </AuthProvider>
    </BrandingProvider>
  </React.StrictMode>
);

